import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/layouts/Navbar';
import Footer from './components/layouts/Footer';
import HomePage from './components/Pages/HomePage';
import AboutPage from './components/Pages/AboutPage';
import ProductsPage from './components/Pages/ProductsPage';
import SingleProductPage from './components/Pages/SingleProductPage';
import BlogPage from './components/Pages/BlogPage';
import SingleBlogPage from './components/Pages/SingleBlogPage';
import ContactPage from './components/Pages/ContactPage';
import GalleryPage from './components/Pages/GalleryPage';
import NoticesPage from './components/Pages/NoticesPage';
import InvestorRelationsPage from './components/Pages/InvestorRelationsPage';
import SuggestionPage from './components/Pages/SuggestionPage';
import PopupModal from './components/features/PopupModal';

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <PopupModal />
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow pt-[100px] lg:pt-[116px]">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:id" element={<SingleProductPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:id" element={<SingleBlogPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/suggestion" element={<SuggestionPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/notices" element={<NoticesPage />} />
            <Route path="/investor-relations" element={<InvestorRelationsPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
